import { Outlet, useRouterState } from "@tanstack/react-router";
import { NuqsAdapter } from "nuqs/adapters/tanstack-router";
import { NavigationPresentation } from "@softmax/design-system";
import { NavigationActivityObserver } from "@softmax/web-features/navigation/activity";
import { NavigationReady } from "@softmax/web-features/navigation/markers";

import { ProductSession } from "@/session/product-session";
import { ProductNavigation } from "@/session/product-navigation";

import "@softmax/design-tokens/tokens.css";
import "@softmax/design-system/global.css";
import "@/styles/fonts.css";
import "@/styles/global.css";

export function Application() {
  const navigation = useRouterState({
    select: (state) => ({
      identity: state.location.pathname + state.location.searchStr,
      pending: state.isLoading,
      resolvedLocation: state.resolvedLocation ?? state.location,
    }),
  });
  return (
    <NuqsAdapter>
      <ProductNavigation>
        <NavigationActivityObserver
          pathname={navigation.resolvedLocation.pathname}
          search={navigation.resolvedLocation.searchStr}
        />
        <NavigationReady stage="shell" />
        <NavigationPresentation
          identity={navigation.identity}
          pending={navigation.pending}
        >
          {navigation.pending && (
            <output
              aria-live="polite"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                zIndex: 10000,
                height: 3,
                background: "#945637",
                pointerEvents: "none",
              }}
            >
              <span
                style={{
                  position: "absolute",
                  width: 1,
                  height: 1,
                  overflow: "hidden",
                  clipPath: "inset(50%)",
                }}
              >
                Opening page…
              </span>
            </output>
          )}
          <ProductSession>
            <Outlet />
          </ProductSession>
        </NavigationPresentation>
      </ProductNavigation>
    </NuqsAdapter>
  );
}
